import { SAVE_ALL_ROKUB, ACTION_GET_ROKOB_RELATION,ROKOB_SEARCH } from "Stores/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  rokubData: [],
  dataRelationRokob: [],
  rokubDataPagination: { Limit: 10, Page: 1, Total: 0 },
  rokubDataSearch: null,

};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_ALL_ROKUB:
      return updateObject(state, {
         rokubData: action.rokubData,
         rokubDataPagination: action.rokubDataPagination,
         });
         case ROKOB_SEARCH:
          return updateObject(state, {
            rokubDataSearch: action.rokubDataSearch,
          });
    case ACTION_GET_ROKOB_RELATION:
      return updateObject(state, {
        dataRelationRokob: action.dataRelationRokob,
      });
    default:
      return state;
  }
};

export default reducer;
